export const GET_UPLOAD_TAG = "GET_UPLOAD_TAG";
export const CREATE_UPLOAD_TAG = "CREATE_UPLOAD_TAG";
export const UPDATE_UPLOAD_TAG = "UPDATE_UPLOAD_TAG";
export const DELETE_UPLOAD_TAG = "DELETE_UPLOAD_TAG";

export const OPEN_DIALOGUE_UPLOAD_TAG = "OPEN_DIALOGUE_UPLOAD_TAG";
export const CLOSE_DIALOGUE_UPLOAD_TAG = "CLOSE_DIALOGUE_UPLOAD_TAG";

export const OPEN_GIVE_UPLOAD_TAG_DIALOGUE = "OPEN_GIVE_UPLOAD_TAG_DIALOGUE";
export const CLOSE_GIVE_UPLOAD_TAG_DIALOGUE = "CLOSE_GIVE_UPLOAD_TAG_DIALOGUE";
